import { STATUSES } from '@/const/status'
import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'

export default {
  namespaced: true,
  state: {
    statuses: STATUSES,
    totalRows: 0,
    studentsPracticalResearch: [],
  },
  getters: {
    statuses: state => state.statuses,
    totalRows: state => state.totalRows,
    studentsPracticalResearch: state => state.studentsPracticalResearch,
  },
  mutations: {
    SET_STATUSES: (state, statuses) => {
      state.statuses = statuses
    },
    SET_TOTAL_ROWS: (state, data) => {
      state.totalRows = data
    },
    SET_STUDENTS_PRACTICAL_RESEARCH: (state, data) => {
      state.studentsPracticalResearch = data
    },
  },
  actions: {
    async readStudentsPracticalResearch({ commit }, params) {
      try {
        const response = await axios.get('uni/practical_research_class_students/getStudentsByGroup', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          const { total, records } = data.data
          commit('SET_STUDENTS_PRACTICAL_RESEARCH', records)
          commit('SET_TOTAL_ROWS', total)
        }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async updateStudentScorePracticalResearchClass({ commit }, params) {
      try {
        const response = await axios.put(`uni/practical_research_class_students/practicalResearchStudentScore`, params)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async createPracticalResearchCheckScore({ commit }, params) {
      try {
        const response = await axios.post('uni/practical_research_check_score', params)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
  },
}
